module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-900italic.d785fb9fc74588ffb7f306799709a97d.woff2";